<h1 mat-dialog-title>
  <p>{{ 'users.policyGroups.selectATag' | t }}</p>
  <h1 mat-dialog-title>
    <mat-form-field appearance="standard" class="load-locations">
      <mat-label class="mat-label"> {{ 'common.selectPageSize' | t }} </mat-label>
      <mat-select [(value)]="selected">
        <mat-option class="mat-option" value="10" (click)="loadTenLocations()"> 10 </mat-option>
        <mat-option class="mat-option" value="20" (click)="loadTwentyLocations()"> 20</mat-option>
        <mat-option class="mat-option" value="all" (click)="loadAllLocations()"> {{ 'common.all' | t }} </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-dialog-content>
      <sn-data-list #list [fetchFn]="loadData">
        <sn-infinite-scroll>
          <sn-pull-to-refresh>
            <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
            <ng-template
              [ngIf]="!list.dataSource.data.length && list.dataIsInited"
              [ngIfThen]="emptyTmpl"
            ></ng-template>
          </sn-pull-to-refresh>
        </sn-infinite-scroll>
      </sn-data-list>
    </mat-dialog-content>
    <mat-dialog-actions snButtonGroup>
      <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
      <button mat-button color="success" (click)="call()">{{ 'users.policyGroups.addTags' | t }}</button>
    </mat-dialog-actions>

    <ng-template #listTmpl>
      <mat-table [dataSource]="list.dataSource.data">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
          <mat-cell *matCellDef="let location">
            {{ location.name }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row (click)="selection.toggle(location)" *matRowDef="let location; columns: columns">
        </mat-row>
      </mat-table>
    </ng-template>

    <ng-template #emptyTmpl>
      <sn-empty-state icon="cancel_presentation" [title]="common.noResults">
        {{ 'common.noResultsMatchSearch' | t }}
      </sn-empty-state>
    </ng-template>
  </h1>
</h1>
